/**
 * Clerk Auth Provider
 *
 * This component sets up the Clerk authentication token getter
 * so that all API requests automatically include the auth token.
 */

import React, { useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { setAuthTokenGetter } from '../../utils/axiosInstance';
import { createLogger } from '../../utils/logger';

const log = createLogger('ClerkAuthProvider');

interface ClerkAuthProviderProps {
  children: React.ReactNode;
}

export const ClerkAuthProvider: React.FC<ClerkAuthProviderProps> = ({ children }) => {
  const { getToken, isLoaded } = useAuth();

  useEffect(() => {
    if (isLoaded) {
      // Set up the token getter function
      setAuthTokenGetter(async () => {
        try {
          const token = await getToken();
          return token;
        } catch (error) {
          log.error('Error getting token from Clerk', error);
          return null;
        }
      });
      log.info('Clerk auth token getter configured');
    }
  }, [getToken, isLoaded]);

  return <>{children}</>;
};
